import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SimilarItemcards({ data }) {
    const S3_URL = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";
    const navigate = useNavigate();

    const [loaderShow, setLoaderShow] = useState(false);
    // const handleSubmit = (event) => {
    //     setLoaderShow(true);
    //     const sku = data.sku;
    //     setTimeout(() => {
    //         navigate(`/rough-country-product-details/${sku}`);
    //         window.location.reload();
    //         setLoaderShow(false);
    //     }, 1000); // Delay of 1000 milliseconds (1 second)
    // };

    const handleSubmit = () => {
        setLoaderShow(true);
        const sku = data.sku;

        setTimeout(() => {
            window.open(`/rough-country-product-details/${sku}`, "_blank");
            setLoaderShow(false);
        }, 1000);
    };

    let first_image_path = "";
    let image = data.image_1.trim(); // Image URL from your data
    let logo = data.logo;

    if (image) {
        first_image_path = image;
    } else if (logo) {
        first_image_path = S3_URL + logo;
    }

    // Create product name dynamically if needed
    let product_name_ = `${data.product_description || 'Unknown Product'}`;

    return (
        <div className="col-lg-2 col-6 customeChanges">
            <div className="Drivetrain-cart wheelsPage">
                {/* {data.msrp_usd && data.msrp_usd >= 100 && (
                    <div className="ribbon"><span>Free Shipping</span></div>
                )} */}

                <div className="engle-imge-upper" onClick={handleSubmit}>
                    {!loaderShow ? (
                        <button className="hover-btn">View Details</button>
                    ) : (
                        <button className="hover-btn loading">Loading</button>
                    )}

                    {data && first_image_path ? (
                        <img className="" src={first_image_path} alt="img" height="100%" width="100%" />
                    ) : (
                        <img className="w-100 h-auto" src="/images/coming_soon.jpg" alt="img" height="100%" width="100%" />
                    )}
                </div>

                <div className="cart-body">
                    <span onClick={handleSubmit} style={{ cursor: 'pointer' }}>
                        {/* <h4 className='similar_pro_cat_name'>{ }</h4> */}
                        {/* <span className="m-0 description text-dark">
                            {data.vendor_id == 12 ? data.product_name : product_name_}
                        </span> */}
                        <h1>{data.category}</h1>
                        <span style={{ cursor: "pointer" }}>
                            <span className="m-0 description text-dark">
                                {data.title || "Rough Country Product"}
                            </span>
                        </span>
                    </span>

                    <div className="price-cart">
                        <div className="price mt-2">
                            <strong>{data.sku}</strong>
                        </div>
                        <div className="price" title="Stock">
                            {data.quantity === 0 ? (
                                <span><i className="fa fa-industry text-danger" aria-hidden="true"></i> {data.quantity}</span>
                            ) : (
                                <span><i className="fa fa-industry text-success" aria-hidden="true"></i> {data.quantity}</span>
                            )}
                        </div>
                    </div>

                    <div className="price-cart mt-3">
                        <div className="price">
                            {data?.price ? (
                                <h1 className="m-0">${parseFloat(data.price).toFixed(2)}</h1>
                            ) : (
                                <h1 className="m-0">N.A</h1>
                            )}
                        </div>

                        <div className="cart-btn">
                            <a
                                // href={`/rough-country?brandname=${data.product_description}`}
                                style={{ cursor: "pointer" }}
                            >

                                <img
                                    src="https://media.roughcountry.com/media/catalog/product/r/c/rc-logo-stamp2.jpg"
                                    alt="Brand Logo"
                                    height="100%"
                                    width="100%"
                                />
                            </a>
                        </div>

                        {/* <div className="cart-btn">
                            <a href={`/wheels?brandname=${data.manufacturer}&brandid=${data.vendor_id}`} style={{ cursor: 'pointer' }}>
                                {data?.logo ? (
                                    <img src={S3_URL + data.logo} alt="img" height="100%" width="100%" />
                                ) : (
                                    <img src="/images/no-image-found.png" alt="img" height="100%" width="100%" />
                                )}
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
